<template>
	<div>
		<div class="person__name">
			{{ value.name }}
		</div>
		<div class="person__info col">
			<div class="person__role">
				{{ value.role }}
			</div>

			<a class="a-none-deco " :href="`tel:${value.phone}`">{{ value.phone }}</a>
			<a class="a-none-deco" target="_blank" :href="`mailto:${value.email}`">{{ value.email }}</a>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: Object,
		},
	},
}
</script>

<style lang="scss">
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';
.person {
	&__name {
		margin-top: 1rem;
		text-transform: uppercase;
		font-weight: 700;
		text-decoration: none;
		margin-bottom: 0.75rem;

		@include respond-below('phone') {
			margin: 0.5rem 0;
		}
	}
	&__role {
		@include respond-below('phone') {
			margin-top: 0.5rem;
		}
	}
	&__info {
		& > * {
			margin-top: 0.2rem;
		}
	}
}
</style>
